import { Plus } from '@phosphor-icons/react'
import React, { useState } from 'react'
import { classesEventStore } from 'state/classes/classesStore'
import StaffAndSalary from './StaffAndSalary'
import Summary from './Summary'

const Calculation: React.FC = () => {
  const { classesData, setFeeModal, setAdditionalFeeData } = classesEventStore(
    store => ({
      classesData: store.classesData,
      setFeeModal: store.setFeeModal,
      setAdditionalFeeData: store.setAdditionalFeeData,
    }),
  )
  const [numberOfStaff, setNumberOfStaff] = useState<number>(1)
  const [estimatedSalary, setEstimatedSalary] = useState<{
    min: number
    max: number
  }>({ min: 0, max: 0 })

  const handleAddFee = () => {
    setAdditionalFeeData(undefined)
    setFeeModal(true)
  }

  return (
    <>
      <div>
        <div>
          <StaffAndSalary
            data={classesData}
            numberOfStaff={numberOfStaff}
            setNumberOfStaff={setNumberOfStaff}
            estimatedSalary={estimatedSalary}
            setEstimatedSalary={setEstimatedSalary}
          />
          <button
            className="flex align-center justify-center gap-10px border-none bg-greyLight py-12px radius-8  w-full mt-25px pointer"
            onClick={handleAddFee}
          >
            <Plus size={10} color="#000" />
            <span className="text-15 w-500">Add more fees</span>
          </button>
        </div>

        <div className="mt-25px">
          <Summary
            data={classesData}
            numberOfStaff={numberOfStaff}
            estimatedSalary={estimatedSalary}
          />
        </div>
      </div>
    </>
  )
}

export default Calculation
